var IframeManager = function () {
  function IframeManager(options) {
    this.iframes = new WeakMap();
    this.mutationCb = options.mutationCb;
  }

  IframeManager.prototype.addIframe = function (iframeEl) {
    this.iframes.set(iframeEl, true);
  };

  IframeManager.prototype.addLoadListener = function (cb) {
    this.loadListener = cb;
  };

  IframeManager.prototype.attachIframe = function (iframeEl, childSn) {
    var _a;

    this.mutationCb({
      adds: [{
        parentId: iframeEl.__sn.id,
        nextId: null,
        node: childSn
      }],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: true
    });
    (_a = this.loadListener) === null || _a === void 0 ? void 0 : _a.call(this, iframeEl);
  };

  return IframeManager;
}();

export { IframeManager };